import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "@/lib/api";
import { KitchenCard } from "@/components/KitchenCard";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export function FavoritesPanel() {
  const [items, setItems] = useState(null);
  const [sendingPreview, setSendingPreview] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/favorites").then(({ data }) => { if (alive) setItems(data); }).catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, []);

  const sendPreview = async () => {
    setSendingPreview(true);
    try {
      const { data } = await api.post("/favorites/digest-preview");
      toast.success(`Digest preview sent to ${data.sent_to}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Preview failed");
    } finally {
      setSendingPreview(false);
    }
  };

  if (items === null) return <div className="tick-label">Loading favorites...</div>;
  if (items.length === 0) {
    return (
      <div data-testid="favorites-empty" className="border hairline p-10 text-center">
        <p className="text-neutral-400">No favorites yet. Tap the heart on any kitchen to save it here.</p>
        <Link to="/browse" className="btn-outline inline-block mt-4">Find kitchens</Link>
      </div>
    );
  }
  return (
    <div>
      <div className="mb-5 flex items-center justify-between flex-wrap gap-3">
        <div className="tick-label">{items.length} saved kitchen{items.length === 1 ? "" : "s"}</div>
        <button
          data-testid="send-digest-preview"
          onClick={sendPreview}
          disabled={sendingPreview}
          className="btn-outline inline-flex items-center gap-2 disabled:opacity-50"
        >
          <Mail size={13} /> {sendingPreview ? "Sending..." : "Preview Sunday digest"}
        </button>
      </div>
      <div data-testid="favorites-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((k) => <KitchenCard key={k.id} k={k} />)}
      </div>
    </div>
  );
}
